import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api, errMessage } from "@/lib/api";
import { usePageMeta } from "@/lib/format";
import { useT } from "@/i18n";
import { AuthShell } from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/components/ui/sonner";

export default function Forgot() {
  const t = useT();
  usePageMeta(t("fp.meta"));
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={t("fp.title")}
      subtitle={t("fp.subtitle")}
      footer={<><Link to="/login" className="font-medium text-primary hover:underline">{t("fp.back")}</Link></>}
    >
      {sent ? (
        <div className="flex flex-col items-center gap-3 rounded-2xl border border-border bg-secondary/40 p-8 text-center" data-testid="forgot-sent">
          <MailCheck className="h-10 w-10 text-success" />
          <p className="text-sm text-muted-foreground">
            {t("fp.sent")}
          </p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5">
            <Label htmlFor="email">{t("fp.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("fp.email_ph")} data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full rounded-full" size="lg" disabled={loading} data-testid="forgot-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("fp.submit")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
